import FileDownload from 'js-file-download';

import {
    ITableReportAttachmentComment,
} from 'components/table-report/components/table-report-actions/actions/attachment-button/attachment-button-types';
import {ECommonMessages, EErrorMessages} from 'shared/constants/messages';
import {IUploadFileExtended} from 'shared/types/files';
import {ERequestType} from 'shared/types/requests';
import {performRequest, showMessage} from 'shared/utils';
import {
    TTableReportAttachmentsRequest,
    TTableReportDownloadAttachmentsRequest,
} from 'store/slices/table-report-slice/table-report-attachments/table-report-attachments-types';

export const tableReportCommentAttachmentsApi = {
    getCommentAttachments: async ({
        docId,
        templateCode,
    }: TTableReportAttachmentsRequest) => performRequest(
        {
            method: ERequestType.GET,
            url: `table-reports/${templateCode}/resource/${docId}`,
        },
    ),
    downloadFile: async ({
        attachmentId,
        templateCode,
        fileName,
    }: TTableReportDownloadAttachmentsRequest) => {
        const fileResponse = await performRequest({
            method: ERequestType.GET,
            url: `table-reports/${templateCode}/resource/file/download/${attachmentId}`,
            responseType: 'blob',
        });

        try {
            FileDownload(fileResponse.data, fileName);
            showMessage({message: ECommonMessages.DOWNLOAD_FILE_SUCCESS});
        } catch {
            showMessage({message: EErrorMessages.FILE_DOWNLOAD, isError: true});
        }
    },
    postCommentAttachments: async (
        requestData: any,
    ) => {
        const {
            templateCode,
            comments,
            docId,
            files,
            filesOnDelete,
            commentsOnDelete,
        } = requestData;

        const formData = new FormData();

        files.forEach((file: IUploadFileExtended) => {
            if (file.file) formData.append('files', file.file as Blob);
        });
        comments.forEach((comment: ITableReportAttachmentComment, index: number) => {
            if (comment.comment) {
                Object.keys(comment).forEach((key: string) => {
                    formData.append(`comments[${index}].${key}`, comment[key]);
                });
            }
        });
        commentsOnDelete.forEach((commentId: number) => {
            formData.append('commentsOnDelete', String(commentId));
        });
        filesOnDelete.forEach((fileId: number) => {
            formData.append('filesOnDelete', String(fileId));
        });
        return performRequest({
            url: `table-reports/${templateCode}/resource/${docId}`,
            method: ERequestType.POST,
            data: formData,
        });
    },
};
